<template>
  <div v-click-outside="() => (isOpen = false)" class="dropdown">
    <Button
      class="dropdown__button"
      theme="white"
      full-width
      size="medium"
      @click="toggleDropDown"
    >
      <template v-if="title">{{ title }} - </template>{{ selectedOptionLabel }}
      <i class="icon" :class="arrowIcon" />
    </Button>
    <ul v-if="isOpen" class="dropdown__panel">
      <li v-for="option in options" :key="option.value" class="dropdown__item">
        <button
          type="button"
          class="dropdown__item-button"
          :disabled="option.disabled"
          @click="handleOptionClick(option)"
        >
          <span class="label">{{ option.label }}</span>
          <span class="status">{{ option.status }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "DropDown",
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      default: null,
    },
    defaultLabel: {
      type: String,
      default: "Select",
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["changed"],
  data() {
    return {
      isOpen: false,
      selectedOption: null,
    };
  },
  computed: {
    arrowIcon() {
      return this.isOpen ? "icon-arrow-up" : "icon-arrow-down";
    },
    selectedOptionLabel() {
      return this.selectedOption
        ? this.selectedOption.label
        : this.defaultLabel;
    },
  },
  mounted() {
    if (this.selected) {
      this.selectedOption = this.options.find(
        (option) => option.value === this.selected
      );
    }
  },
  methods: {
    handleOptionClick(option) {
      this.selectedOption = option;
      this.$emit("changed", option.value);
      this.isOpen = false;
    },
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    doStuff() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.dropdown {
  box-shadow: 0 0 0 0.5px $color-dark;
  position: relative;

  &__item-button {
    background: transparent;
    border: none;
    padding: 14px;
    display: block;
    width: 100%;
    z-index: 1;
    text-align: left;
    cursor: pointer;
    display: flex;
    justify-content: space-between;

    &:disabled {
      cursor: not-allowed;
      color: rgba($color-dark, 0.2);
    }

    &:hover {
      background-color: $color-light;
    }

    .label {
      @include t__utility-label-20;
    }

    .status {
      @include t__utility-label-20;
      font-weight: 400;
      text-transform: none;
    }
  }

  &__panel {
    position: absolute;
    left: 0;
    right: 0;
    background-color: $color-white;
    z-index: 2;
    box-shadow: 0 0 0 0.5px $color-dark;
  }

  ::v-deep() {
    .button .text {
      @include t__utility-label-20;
      text-align: left;
    }
  }

  &__button {
    position: relative;
    text-align: left;
  }
}

.icon {
  font-size: 20px;
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
